import React from "react";
import {HashRouter, Route, Switch } from "react-router-dom";
import Login from "../components/login/login";
import Sale from "../components/sale/sale";
import Inventory from "../components/inventory/inventory";
import "bootstrap/dist/css/bootstrap.min.css";
import Ws from "../components/ws/ws";
import { Redirect  } from "react-router-dom";
import '../assets/styles/global.scss'

class Routes extends React.Component {
  constructor(props) {
    super(props);
    this.isAuthenticate = localStorage.getItem("isAuthenticate")
    this.state = {
      authenticated: false,
      client: new Ws(),
      isAuthenticate: this.isAuthenticate !== undefined ? this.isAuthenticate : false
    };
  }

  isAuthenticated = () => {
    if (!this.state.isAuthenticate) {
      
    }
  };
  render() {
    let user = localStorage.getItem("user");
    return (
      <HashRouter>
        <Switch>
          <Route exact component={() => <Login />} path="/" />
          <Route
            component={() => <Sale title={"Bienvenido"} ws={this.state.client} user={user} />}
            user={this.state.user}
            path="/bienvenido"
          />
        </Switch>
      </HashRouter>
    );
  }
}

export { Routes };
